export default __webpack_public_path__ + "static/media/facebook.6a55d8d5.svg";